export const RMAField = {
  ID: 'id',
  RMA_ID: 'rma_id',
  CUSTOMER_NAME: 'customer_name',
  CONTACT_NO: 'contact_no',
  REPORTED_PROBLEM: 'reported_problem',
  REMARKS: 'remarks',
  INTERNAL_DIAGNOSIS: 'internal_diagnosis',
  RMA_TRANSACTION_INCLUDED_SERIAL: 'rma_transaction_include',
  PRODUCT_ID: 'product_id',
  LISTING_ID: 'listing_id',
  STATUS: 'status',
  CREATED_BY: 'created_by',
  CREATED_AT: 'created_at',
  TURN_AROUND_TIME: 'turnaround_time',
  TECH: 'tech',
  LOCATION: 'location',
  BRANCH: 'branch',
  SUPPLIER_NAME: 'supplier',
  TRANSACTION_NO: 'transaction_no',
  RMA_IMAGES: 'images', // TODO: Change to RMA_IMAGES

  SERIAL_NO: 'serial_no', // FE ONLY
  PRODUCT_NAME: 'product_name' // FE ONLY
};

export const RMAFieldLabel = {
  ID: 'ID',
  CUSTOMER_NAME: 'Customer Name',
  SUPPLIER_NAME: 'Supplier Name',
  TRANSACTION_NO: 'Transaction No.',
  CONTACT_NO: 'Contact No',
  SERIAL_NO: 'Serial No',
  REPORTED_PROBLEM: 'Reported Problem',
  REMARKS: 'Remarks',
  INTERNAL_DIAGNOSIS: 'Internal Diagnosis',
  PRODUCT_NAME: 'Product Name',
  STATUS: 'Status',
  CREATED_BY: 'Created By',
  CREATED_AT: 'Created At',
  TECH: 'Tech',
  LOCATION: 'Location',
  BRANCH: 'Branch',
  RMA_IMAGES: 'Images'
};
